import React, { useState } from 'react';
import {
  Button,
  CondensedMedium,
  Flashy,
  Icon,
  Layout,
  LayoutItem,
  useApi,
} from '@axiom/ui';
import type { Opportunity } from '@axiom/validation';

import { AccountsApi } from '../../api/accounts-api';

import { OpportunityProfileHeaderSyncModal } from './OpportunityProfileHeaderSyncModal';

export const OpportunityProfileHeaderSalesforceSync = ({
  name = 'OPPORTUNITY_PROFILE_HEADER_SALESFORCE_SYNC',
  opportunity,
}: {
  name?: string;
  opportunity: Opportunity;
}) => {
  const [showSyncModal, setShowSyncModal] = useState(false);
  const [{ data: account } = { data: null }] = useApi(
    opportunity.accountId
      ? AccountsApi.readAccount(opportunity.accountId)
      : undefined
  );

  return (
    <Layout name={name} position="right middle" horizontalGutter="12px">
      {account?.salesforceId ? (
        <LayoutItem>
          <Button
            name="CREATE_IN_SALESFORCE_BUTTON"
            pattern="secondary"
            onClick={() => {
              setShowSyncModal(true);
            }}
          >
            Create in Salesforce
          </Button>
        </LayoutItem>
      ) : (
        <>
          <LayoutItem>
            <Flashy color="controlAlert">
              <Icon name="alert-filled" />
            </Flashy>
          </LayoutItem>
          <LayoutItem>
            <CondensedMedium name="APPROVE_ACCOUNT_WARNING">
              Approve or deny this account before creating this opp in SF.
            </CondensedMedium>
          </LayoutItem>
        </>
      )}
      {showSyncModal ? (
        <OpportunityProfileHeaderSyncModal
          opportunityId={opportunity.id}
          onClose={() => {
            setShowSyncModal(false);
          }}
        />
      ) : null}
    </Layout>
  );
};
